/** Where one of Arc's actions is: just started, or finished. */
export enum ArcActivityPhase {
  Start = 'start',
  End = 'end',
}

export enum ArcActivityOutcome {
  Done = 'done',
  /** Prepared, and waiting on the person's approval in the chat. */
  NeedsApproval = 'needs_approval',
  Failed = 'failed',
}

/** A record the action names, by the field that named it (`taskId`, `id`, `clientName`). */
export interface IArcActivityRef {
  key: string
  value: string
}

/**
 * One service Arc runs, as it happens: sent once when it starts and again when it
 * ends, under the same id, so the screen can show Arc working on the very rows
 * it is changing.
 */
export interface IArcActivity {
  id: string
  sessionId: string
  chatHistoryId: string
  phase: ArcActivityPhase
  service: string
  /** The service's AI tier: READ_ONLY, WRITE_SAFE or WRITE_DANGEROUS. */
  tier: string
  /** The title or name of the thing being made or changed, when the params give one. */
  label: string | null
  /** From the params on start; the params and the result on end. */
  refs: IArcActivityRef[]
  outcome: ArcActivityOutcome | null
  approvalId: string | null
}

/** Arc taking the person to a page: an Atlas path, never another site. */
export interface IArcNavigation {
  sessionId: string
  /** The Arc turn that opened it. */
  chatHistoryId: string | null
  /** An Atlas path, like `/projects/<id>`. */
  url: string
  /** What is there, for the note shown as the page changes. */
  label: string | null
}
